const CHECKOUT_LEGAL_ACCEPTANCE_KEY = 'pp_checkout_legal_acceptance_v1';

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function readCheckoutLegalAcceptance(version) {
  if (typeof window === 'undefined') {
    return false;
  }

  const raw = window.localStorage.getItem(CHECKOUT_LEGAL_ACCEPTANCE_KEY);
  if (!raw) {
    return false;
  }

  const parsed = safeParse(raw);
  const accepted = Boolean(parsed?.accepted);
  const acceptedVersion = typeof parsed?.version === 'string' ? parsed.version.trim() : '';

  return accepted && acceptedVersion === version;
}

export function persistCheckoutLegalAcceptance(accepted, version) {
  if (typeof window === 'undefined') {
    return;
  }

  const nextValue = {
    accepted: Boolean(accepted),
    version: String(version || '').trim(),
    updated_at: new Date().toISOString()
  };

  window.localStorage.setItem(CHECKOUT_LEGAL_ACCEPTANCE_KEY, JSON.stringify(nextValue));
}
